import React from 'react';
import { useSelector } from 'react-redux';

import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import { validateCompanyTypes } from '../../../../../../../../../../../../../lib/functions/utils';
import { AuthState } from '../../../../../../../../../../../../../services/redux/authSlice';
import InforPreview from '../../../../../../../../../common/InforPreview';
import SimulationDoneFrozen from '../../../../../../../../../common/SimulationDoneFrozen';
import DialogActionsWrapper from '../DialogActionWrapper';

const ShoppingCartFactoringQuoted2 = (props: any) => {
  const {
    setOpenShoppingCart,
    selectedRequest,
    handleRejectQuote,
    handleQuote,
    setUp,
    selectedId,
  } = props;

  const infoDiv = (
    <InforPreview
      requestType="factoring"
      type="Recieved"
      status="Cotizada"
      selectedRequest={selectedRequest}
    />
  );
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const canAccept = validateCompanyTypes(user, 'FinancingHub');

  return (
    <div>
      <SimulationDoneFrozen
        infoDiv={infoDiv}
        selectedRequest={selectedRequest}
      />
      <DialogActionsWrapper
        type="factoring"
        onClose={() => setOpenShoppingCart(false)}
        selectedRequest={selectedRequest}
        setUp={setUp}
        selectedId={selectedId}
      >
        <CustomButton color="error" onClick={() => handleRejectQuote()}>
          Cancelar solicitud
        </CustomButton>
        {canAccept && (
          <CustomButton color="warning" onClick={() => handleQuote('ACCEPTED')}>
            Aceptar
          </CustomButton>
        )}
      </DialogActionsWrapper>
    </div>
  );
};

export default ShoppingCartFactoringQuoted2;
